<template>
  <div>
    <!-- 头部 -->
    <Top></Top>
    <div class="w">
      <h2>お問い合わせ</h2>
      <p>
        Rakumartをご利用頂きましてありがとうございます。中国仕入れについて、または弊サイトの使い方についてご不明な点がありましたら、<br />
        cahtwork、又は下記お問合せフォームにてご連絡ください。
        <br />お急ぎの方は電話やチャットツールをご利用ください。簡単にお問合せができます。
        <br />
        電話番号：06-7636-8120
      </p>
      <span style="border: 1px solid #f3c622">chatworkアカウントID：RAKUMART-CS</span>
      <a href="https://www.chatwork.com/RAKUMART-CS" target="_blank" rel="noopener noreferrer"> <img
          src="../../assets/img/chatworkLOGO.png" alt style="width: 200px" /></a>

      <p style="color: #f3c622">
        新規登録後、必ず上記chatworkを追加し、専属担当グループ作成後に注文受付可能です、<br />
        チャットワークをお持ちでない場合は下記より新規申請をお願いいたします。
      </p>
      <p>
        日本国内電話受付時間：9：00～17：00（土日、祝日（日本）を除く）
        <br />chatwork受付時間：10：00～19：00（日、祝日（中国）を除く
      </p>
      <p>
        ・上記時間外の受付に関しては翌営業日以降のご返信とさせていただきます。
        <br />・お問い合わせ内容によっては翌営業日以降のご返信となる場合がございます。予めご了承ください。
      </p>
      <p>
        お問合せへの回答をお送りするため、ご連絡先の明記をお願いいたします。
        <br />取扱い商品の検索・詳細仕様の確認はご登録ユーザー様のみへのサービスです。
        <br />お問合せは、事業者様を対象としております。(事業者であれば職人の方なども可能です)
      </p>
      <el-form :model="consultFrom" :rules="ConsultRules" ref="consultFromRef">
        <ul>
          <li>
            <el-form-item prop="name">
              <span>
                <p>氏名:</p>
                <em> (フルネーム)</em>
              </span>
              <div class="input">
                <el-input v-model="consultFrom.name"></el-input>
              </div>
            </el-form-item>
          </li>
          <li>
            <el-form-item>
              <span>
                <p>お客様ID:</p>
                <em>会員ID又は注文/配送ナンバー</em>
              </span>
              <div class="input">
                <el-input v-model="consultFrom.uid"></el-input>
                <!-- <input type="text" /> -->
              </div>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="tel">
              <span> 電話:</span>
              <div class="input">
                <el-input v-model="consultFrom.tel"></el-input>
                <!-- <input type="text" /> -->
              </div>
            </el-form-item>
          </li>
          <li>
            <el-form-item prop="email">
              <span> メールアドレス:※</span>
              <div class="input">
                <el-input v-model="consultFrom.email"></el-input>
                <!-- <input type="text" /> -->
              </div>
            </el-form-item>
          </li>
        </ul>
        <div style="font-size: 20px">
          <h6 style="color: #f3c622">
            ※は入力必須項目です※は必ず入力してくだい。
          </h6>
          <span style="font-size: 20px">お問い合わせ内容 :</span>
        </div>
        <el-form-item prop="content">
          <textarea name id cols="30" rows="10" v-model="consultFrom.content" class="content"></textarea>
        </el-form-item>
      </el-form>
      <!-- <input type="text" v-model="list.content" class="content" /> -->
      <button class="chaxun" @click="consult" :disabled="show">
        問い合わせ内容を確認する
      </button>
    </div>
    <el-dialog title="お問い合わせ　　" :visible.sync="dialogVisible" width="30%" center="center">
      <div>
        <p style="margin: 0; line-height: 30px">
          お問い合わせ誠にありがとうございます。
        </p>
        <p style="margin: 0; line-height: 30px">
          受領致しましたので、内容を精査して後ほど、
        </p>
        <p style="margin: 0; line-height: 30px">
          担当者より、ご連絡させて頂きますので、今暫くお待ち下さいませ。
        </p>
        <p style="margin: 0; line-height: 30px">宜しくお願い致します。</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">確定</el-button>
      </span>
    </el-dialog>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import * as sysTool from "../../assets/js/systemTool";
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
import { consult } from "../../api/API/home";
export default {
  data() {
    return {
      dialogVisible: false,
      show: false,
      count: 30,
      consultFrom: {
        name: "",
        tel: "",
        email: "",
        content: "",
        ip: "",
        uid: "",
      },
      ConsultRules: {
        name: [
          {
            required: true,
            message: "フルネーム入力してください",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "メールアドレス入力してください",
            trigger: "blur",
          },
          {
            type: "email",
            message: "メールアドレス入力してください",
            trigger: ["blur", "change"],
          },
        ],
        tel: [
          {
            required: true,
            message: "電話入力してください",
            trigger: "blur",
          },
        ],
        content: [{ required: true, message: "", trigger: "blur" }],
      },
    };
  },
  methods: {
    consult() {
      this.consultFrom.ip = sessionStorage.getItem("ip");
      this.show = true;
      let that = this;
      var timer = setInterval(() => {
        that.count -= 1;
        if (that.count <= 0) {
          that.show = false;
          that.count = 30;
          clearInterval(timer);
        }
      }, 1000);
      consult(this.consultFrom).then((res) => {
        console.log(res);
        if (res.code != 1) return this.$message.error("未記入欄があります");

        this.dialogVisible = true;
      });
    },
  },
  components: {
    Top,
    Foot,
  },
};
</script>
<style lang='scss' scoped>
.w {
  width: 1200px;
}

h2 {
  font-size: 40px;
  color: #333;
  font-weight: 700;
  text-align: center;
  margin-top: 60px;
}

p {
  margin-top: 58px;
  color: #333;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
}

span {
  line-height: 60px;
  font-size: 16px;
  font-weight: 700;
}

img {
  vertical-align: middle;
}

ul {
  margin-top: 50px;

  li {
    span {
      float: left;
      width: 200px;
      height: 100px;
      font-size: 20px;

      em {
        font-weight: 700;
        color: #f3c622;
        line-height: 10px;
        font-size: 14px;
      }

      p {
        margin: 0;
        font-size: 20px;
      }
    }

    .input {
      width: 300px;
      display: inline-block;
    }
  }
}

.content {
  margin-left: 130px;
  width: 1000px;
  height: 360px;
  resize: none;
  border-color: #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.chaxun {
  display: block;
  width: 300px;
  height: 40px;
  text-align: center;
  color: #333;
  background: #f3c622;
  margin: 40px auto 130px;
  line-height: 40px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 5px;
}

/deep/ .el-form-item__error {
  margin-left: 200px;
  font-size: 20px;
}
</style>